import {
  formatFullName,
  INFO_NOT_AVAILABLE_NA,
} from '@backoffice-frontend/common'
import { useUserHasAccess } from '@backoffice-frontend/restricted'
import { BoumRight } from '@moia-dev/moia-token-claims'

type OperatorNameFormat = 'fullName' | 'abbreviated'

type UseHandledByOperatorArgs = {
  operatorId?: string | null
  operatorDetails?: { firstName: string; lastName: string } | null
  format?: OperatorNameFormat
}

type UseHandledByOperatorResult = {
  isHandled: boolean
  operatorName: string | undefined
}

export const useHandledByOperator = ({
  operatorId,
  operatorDetails,
  format = 'abbreviated',
}: UseHandledByOperatorArgs): UseHandledByOperatorResult => {
  const canReadBackofficeUserData = useUserHasAccess({
    requiredRights: [BoumRight.BACKOFFICE_USER_USER_R],
  })

  if (!operatorId) {
    return { isHandled: false, operatorName: undefined }
  }

  const isNameVisible = canReadBackofficeUserData && operatorDetails != null

  if (!isNameVisible) {
    return { isHandled: true, operatorName: INFO_NOT_AVAILABLE_NA }
  }

  return {
    isHandled: true,
    operatorName: formatFullName({
      givenName: operatorDetails.firstName,
      familyName: operatorDetails.lastName,
      abbreviateFamilyName: format === 'abbreviated',
    }),
  }
}
